module.exports = __webpack_public_path__ + "img/20200610_154844.06aa5f22.jpg";